const IOS_VIEWPORT_CONTENT = 'width=device-width, initial-scale=1, maximum-scale=1';

/** iPhone/iPod, or an iPad, which reports itself as a Mac but has a touch screen. */
export function isIosDevice(): boolean {
	return (
		/iPad|iPhone|iPod/.test(navigator.userAgent) ||
		(navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
	);
}

/**
 * iOS zooms in on any text field under 16px when it is focused and often stays zoomed after
 * the keyboard closes, cutting off the header and adding a sideways scroll until the app
 * restarts. `maximum-scale=1` stops that auto-zoom; iOS still lets people pinch to zoom.
 * Android is left alone, as there the same setting would block pinch zoom.
 */
export function preventIosInputZoom(): void {
	if (!isIosDevice()) return;
	document.querySelector('meta[name="viewport"]')?.setAttribute('content', IOS_VIEWPORT_CONTENT);
}
